import React, { useState } from 'react';
import { Stamp, StampIcon } from 'lucide-react';
import { loadFromUrl } from '../utils/csv/loadFromUrl';

interface LoadSampleProps {
  onSample: (data: string) => void;
  url: string;
  label?: string;
}

export const LoadSample: React.FC<LoadSampleProps> = ({
  onSample,
  url,
  label = 'Load Sample'
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClick = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const csvData = await loadFromUrl(url);
      onSample(csvData);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load CSV');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {error && (
        <div className="text-red-600">
          {error}
        </div>
      )}
      {isLoading ? (
        <button
          onClick={handleClick}
          className="flex items-center gap-2 px-4 py-2 text-blue-600 hover:text-red-800 transition-colors"
          title="Load Sample"
        >
          <Stamp className="w-5 h-5" />
          {label}
        </button>
      ) : (
        <button
          onClick={handleClick}
          className="flex items-center gap-2 px-4 py-2 text-blue-600 hover:text-blue-800 transition-colors"
          title="Load Sample"
        >
          <StampIcon className="w-5 h-5" />
          {label}
        </button>
      )}
    </div>
  );
};
